<template>
    <div>
        <b-modal
            id="add-select-field-popup"
            ref="modal"
            :title="title"
            size="sm"
            hide-footer
            :hide-header-close="loading"
            no-close-on-backdrop
            no-close-on-esc
            modal-class="hide-footer"
            @hidden="hideModal()"
        >
            <b-form @submit.stop.prevent="onSubmit()" @reset="hideModal">
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Label"
                            label-for="label"
                        >
                            <b-form-input
                                id="field-label"
                                v-model="fieldData.label"
                                v-validate="'required|max:100|min:1'"
                                type="text"
                                placeholder="Enter field label"
                                autocomplete="no"
                                data-vv-name="label"
                                :class="{
                                    'is-invalid': errors.has('label'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12 row-min-space">
                        <div class="scrollable more-fields-popup">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="m-b-15" for="options"
                                        >OPTIONS</label
                                    >
                                </div>
                                <div class="col-md-6">
                                    <label class="m-b-15" for="values"
                                        >VALUE</label
                                    >
                                </div>
                            </div>
                            <div
                                v-for="(list, index) in fieldData.options"
                                :key="index"
                                class="row"
                            >
                                <div class="col-md-6">
                                    <b-form-group class="m-b-15">
                                        <b-form-input
                                            :id="'option' + index"
                                            v-model="list.text"
                                            v-validate="
                                                'required|max:100|min:1'
                                            "
                                            :autofocus="
                                                fieldData.options.length > 2
                                                    ? true
                                                    : false
                                            "
                                            type="text"
                                            placeholder="Enter option"
                                            autocomplete="no"
                                            :name="'option' + index"
                                            :class="{
                                                'is-invalid': errors.has(
                                                    'option' + index
                                                ),
                                            }"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group class="m-b-15">
                                        <b-form-input
                                            :id="'value' + index"
                                            v-model="list.value"
                                            v-validate="
                                                'required|max:100|min:1'
                                            "
                                            type="text"
                                            placeholder="Enter value"
                                            autocomplete="no"
                                            :name="'value' + index"
                                            :class="{
                                                'is-invalid': errors.has(
                                                    'value' + index
                                                ),
                                            }"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                                <div
                                    v-if="fieldData.options.length > 2"
                                    class="col-xs-12 col-md-12"
                                >
                                    <span
                                        class="removed-row-class"
                                        @click.prevent="deleteRow(index)"
                                        ><i class="icon-delete"></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 add-more-section">
                                <b-form-group>
                                    <button
                                        class="btn btn-transparent btn-block"
                                        @click.prevent="addOption()"
                                    >
                                        <span class="btn-text">+ Add More</span>
                                    </button>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-4">
                        <b-form-group
                            id="input-group-4"
                            class="kyc-status-radio overwrite-radio mb-0"
                            label="Is Required?"
                            label-for="isrequired"
                        >
                            <b-form-radio-group
                                id="isrequired"
                                v-model="fieldData.isRequired"
                                :options="form.radioOptions"
                                name="isrequired"
                            ></b-form-radio-group>
                        </b-form-group>
                    </div>
                </div>

                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Submit"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                        :disabled="loading"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        /**
         * Value to determine the current compose mode which
         * varies between 'add' and 'edit'
         */
        title: {
            type: String,
            default: 'Add Select Field',
        },
        buttonText: {
            type: String,
            default: 'Create',
        },
        type: {
            type: String,
        },
        icon: {
            type: String,
        },
        route: {
            type: String,
            required: true,
        },
        currentField: {
            type: Object,
        },
        index: {
            type: Number,
        },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */

    data() {
        return {
            optionsLength: 1,
            fieldData: this.initializeFieldData(),
            form: {
                radioOptions: [
                    { text: 'Yes', value: true },
                    { text: 'No', value: false },
                ],
            },
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        hidePopup(value) {
            if (value) {
                this.hideModal()
            }
        },
        currentField(value) {
            if (value) {
                this.fieldData = JSON.parse(JSON.stringify(value))
            }
        },
    },
    methods: {
        hideModal() {
            this.$emit('hide-modal')
            this.$validator.reset()
            this.$refs.modal.hide()
            Object.assign(this.fieldData, this.initializeFieldData())
        },
        initializeFieldData() {
            return {
                association: null,
                isRequired: false,
                isLocked: false,
                dataSegmentId: '',
                section: '',
                sectionTitle: '',
                type: 'dropdown',
                sequenceNumber: 0,
                title: '',
                label: '',
                placeholder: '',
                options: [
                    {
                        text: '',
                        value: '',
                    },
                    {
                        text: '',
                        value: '',
                    },
                ],
                icon: 'icon-select-field',
                maxLength: null,
            }
        },

        async onSubmit() {
            let self = this

            const result = await this.$validator.validateAll()

            let passing = true

            if (result) {
                this.fieldData.placeholder = 'Select ' + this.fieldData.label
                this.fieldData.dataSegmentId = this.dataSegmentId
                this.fieldData.title = this.fieldData.label
                this.fieldData.section = this.route
                this.fieldData.type = this.type
                this.fieldData.icon = this.icon
                this.fieldData.sectionTitle =
                    this.route == 'setup_profile'
                        ? 'Setup Profile'
                        : 'Account Info'

                if (this.$parent.formData) {
                    if (
                        this.buttonText == 'Update' &&
                        this.$parent.formData[this.index].label.toLowerCase() ==
                            self.fieldData.label.toLowerCase()
                    ) {
                        passing = true
                    } else {
                        this.$parent.formData.forEach(function (list) {
                            if (list.label) {
                                if (
                                    list.label.toLowerCase() ==
                                    self.fieldData.label.toLowerCase()
                                ) {
                                    passing = false
                                }
                            }
                        })
                    }
                }
                if (passing) {
                    this.$store.commit('setLoading', true)
                    if (this.buttonText === 'Update') {
                        Object.assign(
                            this.$parent.formData[this.index],
                            this.fieldData
                        )
                        this.$store.commit(
                            'setSuccess',
                            'Field has been updated. Please click on Update Form to save the changes.'
                        )
                    } else {
                        this.$parent.formData.push(
                            JSON.parse(JSON.stringify(self.fieldData))
                        )

                        this.$store.commit(
                            'setSuccess',
                            'Field has been added. Please click on Update to save the changes.'
                        )
                    }

                    setTimeout(function () {
                        self.$store.commit('setChangeDetect', true)
                        self.$store.commit('setLoading', false)
                        self.$refs.modal.hide()
                        self.clearFormData()
                    }, 2000)
                } else {
                    this.$store.commit('setError', 'Field already exists.')
                }
            } else {
                this.$store.commit(
                    'setError',
                    this.errors.all()[0].replace(/[0-9]/g, '')
                )
            }
        },

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.fieldData, this.initializeFieldData())
        },

        async addOption() {
            const result = await this.$validator.validateAll()

            if (result) {
                this.fieldData.options.push({ text: '', value: '' })
            } else {
                this.$store.commit(
                    'setError',
                    this.errors.all()[0].replace(/[0-9]/g, '')
                )
            }
        },
        deleteRow(index) {
            this.fieldData.options.splice(index, 1)
        },
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'dataSegmentId']),
    }, // End of Component > computed
}
</script>
